import ajax from '@/utils/ajax'
export default {
  //录入时间接口
  updateVisitTime(data){
    return ajax({
      url: 'gt6/ai/updateVisitTime',
      method: 'POST',
      data
    })
  },
  // 感兴趣列表接口
  interestList(data) {
    return ajax({
      url: 'gt6/ai/personalityList',
      method: 'POST',
      data
    })
  },
  // 上一次感兴趣列表接口
  checkPersonalityList(data) {
    return ajax({
      url: 'gt6/ai/checkPersonalityList',
      method: 'POST',
      data
    })
  },
   // 不感兴趣企业
  noInterestE(data) {
    return ajax({
      url: 'gt6/ai/getUninterestedList',
      method: 'POST',
      data
    })
  },
  //ai  搜索列表接口
  searchCompanyList(data) {
    return ajax({
      url: 'gt6/ai/searchCompany',
      method: 'POST',
      data
    })
  },
  //感兴趣和恢复接口
  updateInterest(data) {
    return ajax({
      url: 'gt6/ai/updateInterest',
      method: 'POST',
      data
    })
  },
  //获取更新时间接口
  getUpdateTime() {
    return ajax({
      url: 'gt6/ai/getUpdateTime',
      method: 'GET'
    })
  },
  //历史汇总
  getAISummary() {
    return ajax({
      url: 'gt6/ai/summary',
      method: 'GET'
    })
  },

}